import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  value: string;
}

const Wrapper = styled.span`
  display: inline-block;
  padding: 4px 6px;
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};
  border: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  border-radius: ${withVar(RadiusToken.Radius1)};
`;

const Hash = styled.span`
  display: inline-block;
  margin-right: 1px;
  color: ${withVar(DesignToken.ActionPrimaryDefault)};
`;

const Value = styled.span`
  display: inline-block;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-weight: 600;
`;

export const Shortcut: React.FC<IProps> = ({ value }) => (
  <Wrapper>
    <Hash>#</Hash>
    <Value>{value}</Value>
  </Wrapper>
);
